// KpiMetric.meta 타입 + 순수 헬퍼 (shell/DB 무관 — 단위 테스트 용이)
//
// meta 는 metric 의 확장 네임스페이스. 용도별 최상위 키(input/kind/source…)로
// 스키마 재변경 없이 확장한다. (형제 엔티티 Kpi.vizMeta / KpiValue.meta 와 동일 패턴)

export type InputWidget = 'number' | 'rating' | 'select' | 'date' | 'text' | 'toggle'

/** 값 입력 위젯/검증 힌트. */
export interface InputHint {
  widget: InputWidget
  min?: number
  max?: number
  step?: number
  options?: { value: string | number; label: string }[]
  required?: boolean
  decimals?: number
  /** 파생/자동수집 값 등 사용자 입력 불가. 미지정이면 collectType=AUTO 에서 추론. */
  readonly?: boolean
  /** '계획값 vs 실제값' 2열 여부. */
  hasPlan?: boolean
  placeholder?: string
  default?: any
}

/** metric ↔ 소스 바인딩 (값이 어디서 오는지). */
export interface SourceBinding {
  type: 'entityField' | 'dataset' | 'external' | 'manual'
  entity?: string
  field?: string
  datasetId?: string
}

export interface KpiMetricMeta {
  input?: InputHint
  /** 고정속성(attribute) vs 시계열 성과(performance). */
  kind?: 'attribute' | 'performance'
  source?: SourceBinding
  /** 향후 확장(display/validation/collection …) */
  [key: string]: any
}

/**
 * metric 의 "효과적 입력 힌트" 를 결정한다.
 *  - meta.input 이 있으면 그것을 기본값과 함께 사용
 *  - 없으면 안전 폴백(number). **이름 추측 금지.**
 *  - readonly: 명시값 우선(false 도 존중), 미지정이면 AUTO 수집이면 true
 *  - rating: max 기본 5, step 기본 1
 */
export function resolveInputHint(
  metric: { meta?: KpiMetricMeta | null; collectType?: string } | null | undefined
): InputHint {
  const isAuto = metric?.collectType === 'AUTO'
  const hint = metric?.meta?.input

  if (hint?.widget) {
    const readonly = hint.readonly ?? isAuto
    if (hint.widget === 'rating') {
      return { ...hint, max: hint.max ?? 5, step: hint.step ?? 1, readonly }
    }
    return { ...hint, readonly }
  }

  return { widget: 'number', readonly: isAuto }
}
